import {Outlet} from "react-router-dom";
import {NavBar} from "./NavBar";
import {Footer} from "./Footer";

interface PublicLayoutProps {
	headerFixed?: boolean;
	siteName?: string;
	menuMobilePosition?: string;
	containerClasses?: string;
}

export default function PublicLayout({
	headerFixed,
	siteName,
	menuMobilePosition,
	containerClasses
}: PublicLayoutProps) {
	return (
		<div className="min-h-screen flex flex-col bg-body">
			<NavBar fixed={headerFixed} shadow menuMobilePosition={menuMobilePosition} siteName={siteName} />
			<div className={containerClasses}>
				<Outlet/>
			</div>
			<Footer/>
		</div>
	);
}
